// Dynamic WhatsApp message generator for the Bhajan funnel.
// Builds a natural, context-aware pre-filled message so the visitor lands in
// WhatsApp having "already started" the conversation. No sensitive data exposed.

const DEFAULT_NUMBER = "919111895557";

const FALLBACK = {
    GENERAL: "Hi MuviArts, I'd like to discuss a Bhajan or devotional music project.",
    GENERAL_ENQUIRY: "Hi MuviArts, I'd like to discuss a Bhajan or devotional music project.",
    AI_5K: "Hi MuviArts, I'm interested in the AI assisted Bhajan production option (₹5K). I'd like to discuss my project.",
    OWN_VOCALS_15K: "Hi MuviArts, I'm interested in producing a Bhajan using my own vocals (₹9K). I'd like to discuss my project.",
    FULL_ORIGINAL_25K: "Hi MuviArts, I'm interested in full original Bhajan production (₹30K). I'd like to discuss my project.",
    BULK_CUSTOM: "Hi MuviArts, I'm looking for regular devotional music production for weekly/monthly content. I'd like to discuss a custom plan.",
    OWN_VOCALS: "Hi MuviArts, I'm interested in getting a Bhajan produced using my own vocals. I'd like to know the process.",
    FULL_ORIGINAL: "Hi MuviArts, I'm interested in a complete original Bhajan production. I'd like to discuss my project.",
    VIDEO: "Hi MuviArts, I'm interested in Bhajan music production along with a music video. I'd like to know the available options.",
    MONTHLY_BULK: "Hi MuviArts, I'm interested in regular / monthly devotional content production. I'd like to discuss a custom plan.",
    OFFER_INTEREST: "Hi MuviArts, I'd like to discuss a Bhajan or devotional music project.",
    PAID_BOOKING: "Hi MuviArts, my booking is confirmed (Ref: {ref}). I'd like to share my devotional music requirements.",
};

export function waNumber(cfg) {
    return String(cfg?.whatsapp_number || DEFAULT_NUMBER).replace(/\D/g, "") || DEFAULT_NUMBER;
}

export function generateWhatsAppMessage({ state = "GENERAL_ENQUIRY", cfg, ref = "", packageName = "" } = {}) {
    const templates = (cfg && cfg.wa_templates) || {};
    let msg = templates[state] || FALLBACK[state] || FALLBACK.GENERAL_ENQUIRY;
    if (ref) msg = msg.replace(/\{ref\}/g, ref);
    else msg = msg.replace(/\s*\(Ref:\s*\{ref\}\)\.?/g, ".").replace(/\{ref\}/g, "");
    msg = msg.replace(/\{package\}/g, packageName || "");
    return msg.trim();
}

export function waUrl({ state = "GENERAL_ENQUIRY", cfg, ref = "", packageName = "" } = {}) {
    const text = generateWhatsAppMessage({ state, cfg, ref, packageName });
    return `https://wa.me/${waNumber(cfg)}?text=${encodeURIComponent(text)}`;
}
